module.exports = __webpack_public_path__ + "static/media/streamingbackground.fa91dfd8.png";